module.exports = __webpack_public_path__ + "static/media/logo-sizex2.2901dec8.jpg";